<template>
  <div
    class="ad-quality-feedback-link"
    @click.prevent="triggerLinkClick"
  >
    <EFeedbackLink
      ref="feedback-link"
      v-bind="feedbackLinkProps"
      data-test-id="ad-quality-feedback-link"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EFeedbackLink from '~~/common/vue/components/feedback-link';

export default {
  name: 'EAdQualityFeedbackLink',
  components: {
    EFeedbackLink,
  },
  props: {
    widgetType: {
      type: String,
      required: true,
    },
    origin: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('user', ['bingMarketCode']),
    query() {
      return this.$route?.query?.q?.toString();
    },
    feedbackLinkProps() {
      return {
        errorMessage: this.$t('common.header.feedback.error'),
        options: [
          { label: this.$t('common.search.ad.report.bullet1'), value: 'offensive_material' },
          { label: this.$t('common.search.ad.report.bullet2'), value: 'scam_or_misinformation' },
          { label: this.$t('common.search.ad.report.bullet3'), value: 'illegal_substances' },
          { label: this.$t('common.search.ad.report.bullet4'), value: 'irrelevant_content' },
          { label: this.$t('common.search.ad.report.bullet5'), value: 'other' },
        ],
        query: this.query,
        submitText: this.$t('common.header.feedback.send'),
        successMessage: this.$t('common.header.feedback.body2'),
        successTitle: this.$t('common.header.feedback.title2'),
        textareaPlaceholder: this.$t('common.header.feedback.tellmore'),
        title: this.$t('common.search.ad.report.title'),
        ticketSubject: 'Search - Ad Report',
        url: null,
        widgetType: this.widgetType,
        bingMarketCode: this.bingMarketCode,
        origin: this.origin,
      };
    },
  },
  methods: {
    triggerLinkClick() {
      this.$refs['feedback-link'].$refs.link?.$el.click();
    },
  },
};

</script>
